<!--
 * @Description: 置为无效线索弹窗组件
 * @Author: mdb
 * @Date: 2022-11-02 14:51:13
 * @LastEditTime: 2023-03-08 17:55:49
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="t('clue.nvalidModalTitle')"
    width="670px"
    :confirm-loading="loading"
    @ok="handleBecomeInvalidOk"
    @cancel="handleBecomeInvalidCancel"
  >
    <a-form :model="dataForm" ref="formRef" :rules="formRules" :wrapper-col="{ span: 24 }">
      <a-form-item name="clueIdList" :label="t('clue.customerName')">
        <CosSelect
          v-model:value="dataForm.clueIdList"
          :options="selectedData"
          :fieldNames="{ label: 'customerName', value: 'clueId' }"
          mode="multiple"
          :max-tag-count="100"
          disabled
        />
      </a-form-item>
      <dc-form-item name="invalidId" :label="t('clue.invalidReason')" :span="24">
        <ParamCodesSelect v-model:value="dataForm.invalidId" :options="paramCodeData.ofbu_invalid_reason" allowClear />
      </dc-form-item>
      <a-form-item name="remark" :label="t('common.remark')">
        <CosTextarea v-model:value="dataForm.remark" :maxlength="2000" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeMount } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import { salesClueChangeInvalid } from '@/api/overseasSales/clueManage'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { SalesClueListItem, InvalidClueParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const formRef = ref<FormInstance>()
const initForm = { clueIdList: [], invalidId: -9, remark: '' }
const dataForm = ref<InvalidClueParams>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  clueIdList: [{ required: true, message: t('common.pleaseSelect') }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }]
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_invalid_reason']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const init = (data: SalesClueListItem[]) => {
  dataForm.value.clueIdList = data.map((item: SalesClueListItem) => item.clueId)
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    salesClueChangeInvalid(params)
      .then(() => {
        DcMessage.success(t('tips.AbHrgv'))
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleBecomeInvalidCancel = () => {
  formRef.value?.resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'BecomeInvalid' }
</script>

<style lang="scss" scoped></style>
